const affiliationGroups = {
    schools: "בתי ספר",
    learningCenters: "מרכזי למידה",
    privates: "פרטיים"
}

export const affiliationGroupNames = ["בתי ספר", "מרכזי למידה", "פרטיים"]

export default affiliationGroups